// Copyright (c) 2026 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";

import { isSet } from "shared/utils/utils";

interface IInfoRowProps {
  icon: React.ReactNode;
  label: React.ReactNode;
  value: React.ReactNode;
  // when set, renders the label as <label htmlFor> pointing at this field id
  labelFor?: string;
}

// a row of an InfoScreen table: icon, label and value
const InfoRow: React.FC<IInfoRowProps> = ({ icon, label, value, labelFor }) => (
  <tr>
    <td>
      <div className="infoRowIcon">{icon}</div>
    </td>
    <td>
      <div className="infoRowContent">
        {isSet(labelFor) ?
          <label htmlFor={labelFor}>{label}</label>
        : <span>{label}</span>}
        <div>{value}</div>
      </div>
    </td>
  </tr>
);

export default InfoRow;
